<div class="wizard-container">
  <h2>Facturas</h2>

  <div class="step-content">
    <h3>Tipo de Listado</h3>
    <div class="radio-options">
      <label class="radio-item">
        <input
          type="radio"
          name="formalista"
          (click)="formas(0)"
          [checked]="SwLista"
        />
        <span>Listado</span>
      </label>
      <!--<label class="radio-item">
        <input
          type="radio"
          name="formalista"
          (click)="formas(1)"
          [checked]="SwImpre"
        />
        <span>Imprimir / PDF</span>
      </label>-->
      <label class="radio-item">
        <input
          type="radio"
          name="formalista"
          (click)="formas(2)"
          [checked]="SwExcel"
        />
        <span>Hoja Excel</span>
      </label>
    </div>
  </div>

  <!-- Límites de Fechas -->
  <div class="step-content">
    <h3>Límites de Fechas</h3>
    <div class="date-input-group">
      <input
        class="date-input"
        placeholder="Desde dd/mm/yyyy"
        name="d1"
        [(ngModel)]="prifec"
        ngbDatepicker
        #d1="ngbDatepicker"
      />
      <button class="btn-calendar" (click)="d1.toggle()" type="button">
        <fa-icon [icon]="icoFec"></fa-icon>
      </button>
    </div>
    <div class="date-input-group">
      <input
        class="date-input"
        placeholder="Hasta dd/mm/yyyy"
        name="d2"
        [(ngModel)]="ultfec"
        ngbDatepicker
        #d2="ngbDatepicker"
      />
      <button class="btn-calendar" (click)="d2.toggle()" type="button">
        <fa-icon [icon]="icoFec"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Botón de acción -->
  <div class="step-content text-center botones">
    <button class="btn btn-cave me-2" (click)="listado()">
      <fa-icon [icon]="icoVal"></fa-icon> Listar
    </button>
    <button class="btn btn-cave" (click)="descargarPDF()">
      <fa-icon [icon]="icoFac"></fa-icon> Descargar PDF
    </button>
  </div>

  <!-- Loading -->
  <div class="loading" *ngIf="resul">
    <div class="spinner"></div>
  </div>
</div>
